import { WelcomeMerchantModal } from 'components/WelcomeMerchantModal'
import { useRouter } from 'next/router'

export const AuthBrowse = () => {
  const router = useRouter()

  const showWelcomeMerchantModal = router.query.welcome === 'merchant'

  const handleWelcomeMerchantModalClose = async () => {
    const { pathname, query } = router
    delete router.query.welcome
    await router.replace({ pathname, query }, undefined, { shallow: false })
  }

  return (
    <>
      {showWelcomeMerchantModal && (
        <WelcomeMerchantModal onClose={handleWelcomeMerchantModalClose} />
      )}
    </>
  )
}
